/* 
Pantalla de movimientos compuesta por TableMovements
*/

import React from "react";

//REDUX
import { useSelector } from "react-redux";


//CONSTANTS
import FORMATNUMBER from "../constants";

//COMPONENTS
import TableMovements from "../components/TableMovements";

//#region CSS
import { makeStyles } from "@material-ui/core/styles";
import Fade from "@material-ui/core/Fade";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
const useStyles = makeStyles(theme => ({
  root: {
    marginTop: "30px",
    height: "100vh"
  }
}));
//#endregion

export default function ListMovements(props) {
  const classes = useStyles();

  const user = useSelector(state => state.user.user);

  return (
    <div className={classes.root}>
      <div>
        <Grid container justify="center" alignItems="center">
          <Fade in={true} timeout={1000}>
            <Grid
              container
              justify="center"
              alignItems="center"
              spacing={3}
              item
              xs={12}
            >
              <Grid item xs={12}>
                <Box textAlign="center">
                  <Typography color="primary" variant="h4" data-lang="movements_title">
                    Lista de Movimientos
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={12}>
                <Box textAlign="center">
                  <Typography color="secondary" variant="h5" data-lang-html="movements_total_points" data-lang-vars={JSON.stringify({points: FORMATNUMBER(user.points)})}>
                    Tiene un total de {FORMATNUMBER(user.points)} puntos
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={12} md={10} lg={8}>
                <TableMovements userId={user.id} />
              </Grid>
            </Grid>
          </Fade>
        </Grid>
      </div>
    </div>
  );
}
